var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    y: 0,
    width: 30,
    height: 30
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.6,1.5c.3.3-.2,1,0,1.4s1.2.4,1.4.6.9.6,1.2.5c.4,0,.4-.7.6-.8.4-.4,1.3.3,1.8.5s.7,0,1.1.2c.6.1.7.9,1,1.3s.5.5.7.8c.8,1.1,1.1,3,1.9,3.9s.5.3.6.6.6,1.2.7,1.2c.8.4,2.2-1,2.5-.8,0,.3-.2.7-.4,1-.9,1.6-2.3,3.2-3.3,4.8s-.2,2.7-.5,4.6-1.3.9-1.6,1.7,0,.9,0,1.5c-.1,1-2.1,3.3-3,3.8s-2.4.7-2.8-.5-.4-2.7-.7-3.9-1.1-2-.7-3.2.9-1,.4-2-1.4-1.6-1.3-2.9.6-1.2-.5-1.8-1.8-.6-2.7-.5-1.6.9-3,.4-2.5-2.1-2.6-3.4.3-3.4.6-4.2,1.1-1.1,1.6-1.7.7-1.1,1.1-1.6c.6-.8,1-.5,1.8-.7s1.7-.5,2.5-.6,1.2-.2,1.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5,20.1c.4,1-.2,1.8-.5,2.7s-.3,1.8-1,2.2-.8-.8-.7-1.2.4-.7.4-1.2,0-.7,0-1,.6-.4.9-.6c.4-.3.5-.7.8-.9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfr);
export default __webpack_public_path__ + "static/media/AFR.a9cf16b0760ad89caba9fa241c852aba.svg";
export { ForwardRef as ReactComponent };